import { render, staticRenderFns } from "./ActivityUserSelector.vue?vue&type=template&id=00daa7f1&scoped=true&"
import script from "./ActivityUserSelector.vue?vue&type=script&lang=ts&"
export * from "./ActivityUserSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00daa7f1",
  null
  
)

export default component.exports